const integrationNamesFormatting = {
  node: 'Node.js (Express.js)',
  cloudflare: 'Cloudflare',
  nginx: 'Nginx',
  apache: 'Apache',
  iis: 'IIS',
  ruby: 'Rails (Ruby)',
  fastly: 'Fastly',
  NextJS: 'Next.js',
  'magento-2': 'Magento 2',
  other: 'Other',
  nuxt: 'Node.js (Nuxt.js)',
  docker: 'Docker',
  firebase: 'Firebase (with Cloudflare)',
  hapi: 'Hapi (JavaScript)',
  koa: 'Koa (JavaScript)',
  django: 'Django (Python)',
  'aspnet-core': 'ASP.NET Core',
  spring: 'Spring (Java)',
  laravel: 'Laravel (PHP)',
  'lovable-free': 'Lovable (Free plan)',
  'lovable-paid': 'Lovable (Paid plan)',
  akamai: 'Akamai',
  bubble: 'Bubble.io',
};

export function formatIntegration(integration) {
  const formattedIntegrationName = integrationNamesFormatting[integration];
  if (!formattedIntegrationName) {
    throw new Error(`Missing formatting for integration: ${integration}`);
  }
  return formattedIntegrationName;
}
